import 'uni-pages';import '@dcloudio/uni-stat';

import Vue from 'vue'            
import Page from './pages/scenicTutorials/components/spotDetail.vue'
createPage(Page)